import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { getAuth } from  "./globals/backend/authClient";
import { SpeedInsights } from "@vercel/speed-insights/react"

const auth = getAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App auth={auth} />
      <SpeedInsights />
    </HashRouter>
  </React.StrictMode>
);
